import { Link } from '@tanstack/react-router'
import { useLang } from '@/i18n/useLang'
import { useLocalized } from '@/i18n/useLocalized'
import { useConsentStore } from './consent-store'

/**
 * Нижняя плашка согласия на аналитические cookie.
 *
 * Ничего не решает сама: весь смысл — два вызова в `consent-store.ts`. Здесь
 * важно другое — плашки НЕТ в собранной статике. Компонент рисуется только
 * после того, как `hydrate()` в браузере прочитал сохранённый ответ (`visible`
 * до этого момента ложь у всех), поэтому `renderToString` на сборке отдаёт
 * пустоту, и вопрос про cookie не уезжает в HTML, который читает поисковик.
 */
export function ConsentBanner() {
  const { t } = useLang()
  const L = useLocalized()
  const visible = useConsentStore((s) => s.visible)
  const decide = useConsentStore((s) => s.decide)

  if (!visible) return null

  return (
    <div className="consent-bar" role="region" aria-label={t.consent.label}>
      <p className="consent-text">{t.consent.text}</p>
      <div className="consent-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => decide('granted')}>
          {t.consent.accept}
        </button>
        <button type="button" className="btn btn-outline btn-sm" onClick={() => decide('necessary')}>
          {t.consent.necessary}
        </button>
        <Link to={L('/privacy')} className="consent-more">
          {t.consent.more}
        </Link>
      </div>
    </div>
  )
}
